<p-autoComplete
  [(ngModel)]="selectedValue"
  [suggestions]="searchPlaceResults"
  (completeMethod)="searchPlaces($event)"
  (onSelect)="onSelect($event)"
  [minLength]="1"
  optionLabel="name"
  styleClass="w-full"
  [appendTo]="'body'"
  [panelStyleClass]="'location-search-panel'"
  [autoZIndex]="true"
  [baseZIndex]="3000"
  (onBlur)="onTouched()"
></p-autoComplete>
